import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import './Header.scss';
/*Assets imported */

/* Material Imports */
import AppBar from '@material-ui/core/AppBar';
import ToolBar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';

//Custom Styles for component
import { useStyles } from './Header.Styles';
import User from '../../models/User';
import { tabIndexes } from '../../models/TabIndexes';
import NotificationsModal from '../Notifications/NotificationsModal/NotificationsModal';
import { getNotificationsFromApi, getNotificationsTotalCountFromApi } from '../../redux/actions/notifications';

import Notifications from '../../models/Notifications';
import { isMobile } from '../../services/booleanUtil';
import ConvergenceModal from '../Util/Modals/ConvergenceModal/ConvergenceModal';
import LogoBidCartera from '../Util/LogoBidCartera/LogoBidCartera';
import { setTabValue } from '../../redux/actions/tabValue';
import { Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { BidTooltip } from '../Util/Tooltip/Tooltip';

import { ReactComponent as HelpCenterIcon } from '../../assets/icons/u_question-blue.svg';
import { ReactComponent as NotificationsIcon } from '../../assets/icons/new-notifications-icon.svg';
import { ReactComponent as Settingsicon } from '../../assets/icons/new-settings-icon.svg';


interface IProps extends React.HTMLProps<JSX.Element> {
  detailProject?: boolean;
  isContentManager?: boolean;
}

export const hasUnreadedElements = (totalCount: number) => {
  return totalCount > 0;
};
export const UserAlertAvatar = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector<any, User>(state => state.user);
  const [hasAlert, setAlert] = React.useState(true);
  const [modalOpen, setModaleOpen] = React.useState(false);
  const notificationsItems = useSelector<any, Notifications[]>(state => state.notifications);
  const notificationsTotalCount = useSelector<any, number>(state => state.notificationsTotalCount);

  const handleOpenModal = () => {
    setModaleOpen(true);
  };

  const handlerCloseModal = () => {
    setModaleOpen(false);
  };
  const dispatchNotifications = () => {
    dispatch(getNotificationsFromApi());
    dispatch(getNotificationsTotalCountFromApi());
  };

  React.useEffect(() => {
    if (user.id > 0) {
      dispatchNotifications();
    }
  }, [user]);

  React.useEffect(() => {
    setAlert(hasUnreadedElements(notificationsTotalCount));
  }, [notificationsTotalCount]);

  return (
    <div>
      <BidTooltip
        arrow
        title={t('alert_tooltip') || ''}
      >
        <IconButton onClick={handleOpenModal}>
          <div className='badge-notifications-content'>
            <NotificationsIcon />
            {hasAlert && (
              <div className='badge-notifications'>
                <p className='m-0 p-0'>{notificationsTotalCount > 9 ? '+9' : notificationsTotalCount}</p>
              </div>
            )}
          </div>
        </IconButton>
      </BidTooltip>
      <NotificationsModal closeModal={handlerCloseModal} isOpen={modalOpen} />
    </div>
  );
};

export const UserAdjustAvatar = ({ detailProject, isContentManager }: IProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const userAdjustHandler = () => {
    dispatch(setTabValue(tabIndexes.userSettings));
    if (detailProject || isContentManager) {
      history.push('/home');
    }
  };

  return (
    <BidTooltip
      arrow
      title={t('user_avatar_tooltip') || ''}
    >
      <IconButton onClick={userAdjustHandler}>
        <Settingsicon />
      </IconButton>
    </BidTooltip>
  );
};

export const HelperAvatar = () => {
  const { t } = useTranslation();

  const handleHelpClick = () => {
    window.open('https://idbg.sharepoint.com/sites/OLP/SitePages/Areas/Smart_Portfolio/Home.aspx?web=1', '_blank');
  };

  return (
    <BidTooltip
      arrow
      title={t('help_tooltip') || ''}
    >
      <IconButton onClick={handleHelpClick}>
        <HelpCenterIcon className='icon-helper-style' />
      </IconButton>
    </BidTooltip>
  );
};

const Header = ({ detailProject, isContentManager }: IProps) => {
  const { root, headerContainer, userGreeting, userActiveRole, rootDetail, detailContainer, toolBar } = useStyles();
  const dispatch = useDispatch();
  const user = useSelector<any, User>(state => state.user);
  const convergenceModal = useSelector<any, any>(state => state.convergenceModal);
  const { t } = useTranslation();
  const history = useHistory();

  const goToHome = () => {
    dispatch(setTabValue(tabIndexes.portfolio));
    history.push('/home');
  };

  return (
    <>
      <div
        className={detailProject ? rootDetail : root}
        style={convergenceModal ? { marginTop: isMobile() ? 50 : 24 } : {}}
      >
        <AppBar className={detailProject ? detailContainer : headerContainer} elevation={0} position="static">
          <ToolBar disableGutters={true} className={toolBar}>
            <LogoBidCartera customStyle={{ flexGrow: 1 }} onClick={goToHome} isContentManager={isContentManager} />

            {!isMobile() && (
              <article>
                <Typography className={userGreeting}>
                  {user.name ? t('greet') : ''} {user.name}
                </Typography>
                <Typography className={userActiveRole}>
                  {user.role ? user.role?.name : ''}
                </Typography>
              </article>

            )}

            <div className='line-width' />

            <div className='icons-content'>

              <HelperAvatar />

              <UserAlertAvatar />

              <UserAdjustAvatar detailProject={detailProject} isContentManager={isContentManager} />
            </div>

          </ToolBar>
        </AppBar>
      </div>
      {convergenceModal && <ConvergenceModal />}
    </>
  );
};

export default Header;
